export default __webpack_public_path__ + "static/museum-c3dee69a0fb6c6844bdaca3c0f62b42f.svg";